export const DOCUMENTS_FORM = {
    'DOCUMENTS.ADD_DOCUMENTS.CLIENT': 'Client',
    'DOCUMENTS.ADD_DOCUMENTS.COMPANY': 'Companie',
    'DOCUMENTS.ADD_DOCUMENTS.UPLOAD_DOCUMENTS': 'Adaugă documente suport',
    'DOCUMENTS.ADD_DOCUMENTS.UPLOAD_DOCUMENTS_TITLE': 'Încarcă documente',
    'DOCUMENTS.ADD_DOCUMENTS.UPLOAD_DOCUMENTS_DESCRIPTION': 'Trage și eliberează aici documentele sau click aici pentru a căuta fișierele',
    'DOCUMENT.ADD_DOCUMENTS.VALIDATION.SELECT_CLIENT': 'Selectați un client',
    'DOCUMENT.ADD_DOCUMENTS.VALIDATION.SELECT_COMPANY': 'Selectați o companie',
    'DOCUMENT.ADD_DOCUMENTS.VALIDATION.AT_LEAST_ONE_DOCUMENT': 'Atașaţi cel puţin un document',
    'DOCUMENT.ADD_DOCUMENTS.VALIDATION.SIZE_EXCEEDED': 'Documentele adăugate depășesc limita de spaţiu permisă clientului selectat',
    'DOCUMENT.ADD_DOCUMENTS.VALIDATION.FILE_ALREADY_UPLOADED': 'Documentul este deja încărcat pentru această companie'
};
